import type { Adaptors } from '@reactvideoeditor/react-video-editor/types';
import {
  ASPECTLY_QR_STICKER_TEMPLATE_ID,
  buildAspectlyQrStickerContent,
} from '@/rve/aspectlyQrStickerContent';

type StickerAdaptor = NonNullable<Adaptors['stickers']>[number];

const QR_ADAPTOR_META = {
  name: 'aspectly-qr',
  displayName: 'QR Code',
  description: 'Destination URL QR widgets',
  requiresAuth: false,
} as const;

/**
 * Sticker adaptor catalog (forward-compatible).
 *
 * RVE 5.3.x still reads built-in sticker templates from its bundle; Aspectly
 * registers the QR sticker via ``aspectlyRveStickerPatch`` instead.
 */
export function createAspectlyQrStickerAdaptor(): StickerAdaptor {
  return {
    ...QR_ADAPTOR_META,
    async getCategories() {
      // SDK StickerCategory union is narrower than runtime sidebar tabs.
      return { items: ['Default' as const] };
    },
    async getTemplates(category) {
      if (category && category !== 'Default') {
        return { items: [], totalCount: 0 };
      }
      return {
        items: [
          {
            id: ASPECTLY_QR_STICKER_TEMPLATE_ID,
            name: 'QR Code',
            category: 'Default',
            layout: 'double',
            defaultProps: {
              durationInFrames: 150,
              styles: { opacity: 1, scale: 1, zIndex: 1 },
            },
          },
        ],
        totalCount: 1,
      };
    },
  };
}

/** Build initial sticker ``content`` after the user confirms a URL (tests / tooling). */
export async function buildQrStickerContentForUrl(url: string): Promise<string> {
  return buildAspectlyQrStickerContent(url);
}
